import React from 'react'
import PageTemplate from 'components/page-template'

const Dashboard = () => (
  <PageTemplate
    title='Dashboard'
    description='latest activity & stats'
    noContainer
  >
    <div className='portlet light'>
      <div className='content'>
        <center>
          <div className='font-blue-sharp bold uppercase'>Thanks for authorising your @handle and providing us with the necessary permission to run the Twitter Experience for you.</div>
        </center>
        <center>
          <p>Our Activations team will setup the experience from here and no further action on this interface would be required from you.</p>
        </center>
        <center>
          <p>Please ensure that you were logged into Twitter.com with the @handle that the experience will be running on and not your Agency @handle which has access to the clients handle as it would be required to be logged into that handle on twitter.com regardless if you have access to the clients @handles via the Ads Dashboard for example.</p>
        </center>
      </div>
    </div>
  </PageTemplate >
)

Dashboard.displayName = 'Dashboard'

export default Dashboard



// WEBPACK FOOTER //
// ./src/pages/dashboard/index.js